var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticClass:"bread-crumbs",staticStyle:{"margin-top":"-18px"},attrs:{"items":_vm.data,"large":""},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('v-breadcrumbs-item',{attrs:{"to":item.to,"exact":item.exact}},[_vm._v(" "+_vm._s(item.text.toUpperCase())+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }